import { render, staticRenderFns } from "./MonthyPlan.vue?vue&type=template&id=6a411ca2&scoped=true&"
import script from "./MonthyPlan.vue?vue&type=script&lang=js&"
export * from "./MonthyPlan.vue?vue&type=script&lang=js&"
import style0 from "./MonthyPlan.vue?vue&type=style&index=0&id=6a411ca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a411ca2",
  null
  
)

export default component.exports